<div fxLayout="column" class="ec-resource-tree-container">
    <ng-container *ngIf="network; else loadingNetwork">
        <div fxLayout="column" class="ml-30 mr-30 mt-18">
            <div class="txt-h-20-7">
                {{'Energy resources'|i18n}}
            </div>
            <div fxLayout="row" fxLayoutAlign="center" class="mt-18 mb-18">
                <div app-input-container class="find-resource-container">
                    <input app-input class="find-resource txt-s-14-4"
                           [ngModel]="searchText" (ngModelChange)="onChangeSearchText($event)"
                           [placeholder]="'Search for resource'|i18n">
                    <app-icon *ngIf="hasSearchText" name="fal-times" class="right-symbol clear"
                              (click)="onClickResetSearchText()">
                    </app-icon>
                    <svg *ngIf="!hasSearchText" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                         class="right-symbol mag-glass">
                        <!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                        <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352c79.5 0 144-64.5 144-144s-64.5-144-144-144S64 128.5 64 208s64.5 144 144 144z"/>
                    </svg>
                </div>
            </div>
        </div>
        <div class="resource-tree-container ml-30 mb-18">
            <mat-tree class="resource-tree" [dataSource]="dataSource" [treeControl]="treeControl">
                <mat-tree-node *matTreeNodeDef="let node"
                               matTreeNodePadding matTreeNodePaddingIndent="16"
                               [ngClass]="{'selected': node.id === selectedNodeId, 'collapsed': !nodeFound(node)}"
                               (click)="onSelectNode(node)">
                    <div *ngIf="nodeFound(node)" fxLayout="row" fxLayoutAlign="start center"
                         class="resource-tree-node">
                        <div>
                            <!-- use a disabled button to provide padding -->
                            <button *ngIf="!node.expandable" mat-icon-button disabled></button>
                            <ng-container *appVar="treeControl.isExpanded(node) as expanded">
                                <!-- NOTE: when click handler is called, `expanded` has already been updated! -->
                                <button *ngIf="node.expandable" mat-icon-button matTreeNodeToggle>
                                    <app-icon [name]="expanded ? 'fal-chevron-down' : 'fal-chevron-right'">
                                    </app-icon>
                                </button>
                            </ng-container>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <div>
                                <app-icon *ngIf="node.icon as icon" [name]="node.icon" class="mr-16">
                                </app-icon>
                            </div>
                            <div [ngSwitch]="node.type">
                                <span *ngSwitchCase="NodeType.NETWORK" class="txt-h-16-7">
                                    {{node.name}}
                                </span>
                                <span *ngSwitchCase="NodeType.POD" class="txt-h-14-7">
                                    {{node.name}}
                                </span>
                                <span *ngSwitchDefault class="txt-h-12-4">
                                    {{node.name}}
                                </span>
                            </div>
                        </div>
                    </div>
                </mat-tree-node>
            </mat-tree>
        </div>
    </ng-container>
</div>

<ng-template #loadingNetwork>
    <div fxLayout="row" fxLayoutAlign="center center" class="ml-30 mr-30 mt-18 mb-18">
        <mat-spinner app-spinner diameter="20"></mat-spinner>
        <span class="pl-8">{{'Loading'|i18n}}...</span>
    </div>
</ng-template>
